import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { formatDateString } from "@circle-react/helpers/dateTimeHelpers/getLocalizedDate";
import { isPublicStream } from "@circle-react/helpers/liveStreamRoomHelpers";
import type { Room } from "@circle-react/types/Live/Room";
import { Duration } from "./Duration";
import { Recording } from "./Recording";
import { RecordingDuration } from "./Recording/RecordingDuration";

interface DetailsProps {
  refetch: () => void;
  room: Room;
}

export const Details = ({ room, refetch }: DetailsProps) => {
  const date = formatDateString(room.live_at || room.created_at, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return (
    <div className="text-dark flex flex-col gap-y-6 py-6 text-sm font-normal">
      {room.recording_attachment && (
        <Recording
          room={room}
          recording={room.recording_attachment}
          refetch={refetch}
        />
      )}
      {room.description && (
        <div>
          <Typography.LabelSm weight="medium">
            {t("live_streams.dashboard.details.description")}
          </Typography.LabelSm>
          <div className="break-words pr-12">
            <Typography.BodySm>{room.description}</Typography.BodySm>
          </div>
        </div>
      )}
      <div>
        <Typography.LabelSm weight="medium">
          {t("live_streams.dashboard.details.room_id")}
        </Typography.LabelSm>
        <Typography.BodySm>{room.id}</Typography.BodySm>
      </div>
      <div>
        <Typography.LabelSm weight="medium">
          {t("live_streams.dashboard.details.date")}
        </Typography.LabelSm>
        <Typography.BodySm>{date}</Typography.BodySm>
      </div>
      {room.duration !== null && room.duration !== undefined && (
        <Duration durationInSeconds={room.duration} />
      )}
      {room.recording_duration && (
        <RecordingDuration recording_duration={room.recording_duration} />
      )}
      {isPublicStream(room) && (
        <div>
          <Typography.LabelSm weight="medium">
            {t("live_streams.dashboard.details.guests_count")}
          </Typography.LabelSm>
          <Typography.BodySm>{room.guests_count}</Typography.BodySm>
        </div>
      )}
    </div>
  );
};
